/**
 * Взять ближайший родительский элемент с указанным именем тэга.
 * 
 * @param element Исходный элемент.
 * @param tagName Имя тэга.
 */
function getClosestByTagName(
	element: Element,
	tagName: string,
): Element | null
{
	let currentElement: Element | null = element;
	
	while (
		( currentElement !== null )
		&& ( currentElement.tagName !== tagName )
	)
	{
		currentElement = currentElement.parentElement;
	}
	
	return currentElement;
}

/**
 * Module.
 */
export {
	getClosestByTagName as default,
};



// WEBPACK FOOTER //
// ./utils/nodes/getClosestByTagName.ts